// 在这里注册活动组件
export default {
  1301: () => import('./InviterPanel'),
  1302: () => import('./InviteePanel')
};
